<template>
  <section>
    <Loader :visible="loading"></Loader>
    <div class="contact-container container mt-30">
      <div class="row">
        <div class="col-md-2 col-1"></div>
        <div class="col-md-8 col-10">
          <div align="center">
            <h2 class="page-title">{{$t('auth.signUp.create')}}</h2>
          </div>
          <div class="row mt-5 margin-form-bottom">
            <div class="col-md-12">
              <form @submit.prevent="send" method="post">
                <div class="col-md-12" align="center">
                  <InputForm v-model="register.email" class="input-width-1-2"
                             :placeholder="$t('auth.email')"
                             v-validate="'required|email'"
                             name="email"/>
                </div>
                <div class="col-md-12" align="center">
                  <InputForm v-model="register.password"
                             :kind="'password'" class="input-width-1-2"
                             :placeholder="$t('auth.password')"
                             v-validate="'required'"
                             name="password"/>
                </div>

                <div class="row" align="center">
                  <div class="col-md-12">
                    <button type="submit" class="primary-btn-light input-width-1-2">
                      {{$t('continue')}}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-md-12" align="center">
              <p>{{$t('auth.signIn.hasAccount')}} <router-link to="" class="text-color-primary">{{$t('auth.signIn.title')}}</router-link></p>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-1">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Loader from "../../components/Loader"
import Register from "../../models/Register"
import InputForm from "../../components/InputForm.vue";

export default {
  name: "Register",
  components: {
    InputForm,
    Loader
  },
  data() {
    return {
      loading: false,
      register: new Register()
    }
  },
  methods: {
    async send() {
      this.loading = true
      this.$alertify.success('Registro correcto')
      this.loading = false
    },
  }
}
</script>

<style lang="scss">
@import '../../scss/variables';
@import '../../scss/landing/main';

.contact-container {
  margin-bottom: 80px;
}

.input-width-1-2 {
  width: 50% !important;
}

.margin-form-bottom {
  margin-bottom: 100px;
}

@media (max-width: 768px) {
  .input-width-1-2 {
    width: 100% !important;
  }
}
</style>
